module.exports = __webpack_public_path__ + "img/huntington.c0b957e2.png";